import React from 'react';
import { Storage } from 'react-jhipster';

/**
 * Formats an amount with its currency symbol/code,
 * respecting Arabic (RTL) locale by placing the currency BEFORE the amount.
 *
 * English : "1,000 USD"
 * Arabic  : "USD 1,000"
 *
 * @param amount   - Already-formatted number string (e.g. from .toLocaleString())
 * @param currency - Currency code or name (e.g. "USD", "KWD")
 * @returns JSX element with correct currency + amount order
 *
 * Usage:
 *   {formatCurrency(quotationEntity?.amount?.toLocaleString(), quotationEntity?.buyCurrency)}
 */
export const formatCurrency = (
  amount: string | number | null | undefined,
  currency: string | null | undefined
): JSX.Element => {
  const isArabic = Storage.session.get('locale') === 'ar-ly';
  const safeAmount = amount ?? '';
  const safeCurrency = currency ?? '';

  return isArabic
    ? <>{safeCurrency}&nbsp;{safeAmount}</>
    : <>{safeAmount}&nbsp;{safeCurrency}</>;
};
